export const selectMyProfile = (state) => state.teamProfile;
